import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_SUBJECTGROUP,
  GET_SUBJECTGROUPS,
  ADD_SUBJECTGROUP,
  UPDATE_SUBJECTGROUP,
  DELETE_SUBJECTGROUP
} from '@/queries/modules/common-data/subjectGroup';

export async function getSubjectGroups(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_SUBJECTGROUPS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSubjectGroups', data.getSubjectGroups);
      context.commit('setSuccess', null);
      return data.getSubjectGroups
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getSubjectGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_SUBJECTGROUP,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSubjectGroup', data.getSubjectGroup);
      context.commit('setSuccess', null);
      return data.getSubjectGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addSubjectGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_SUBJECTGROUP,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const subjectGroups = [...context.state.subjectGroups];
      subjectGroups.push(data.addSubjectGroup);
      context.commit('setSubjectGroups', subjectGroups);
      context.commit('setSuccess', newItemSuccess(data.addSubjectGroup.nameLocal));

      return data.addSubjectGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateSubjectGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_SUBJECTGROUP,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.subjectGroups.findIndex(item => item.id === data.updateSubjectGroup.id);
      const subjectGroups = [
        ...context.state.subjectGroups.slice(0, index),
        data.updateSubjectGroup,
        ...context.state.subjectGroups.slice(index + 1)
      ];
      context.commit('setSubjectGroups', subjectGroups);
      context.commit('setSuccess', updateItemSuccess(data.updateSubjectGroup.nameLocal));

      return data.updateSubjectGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteSubjectGroup(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_SUBJECTGROUP,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.subjectGroups.findIndex(item => item.id === data.deleteSubjectGroup.id);
      const subjectGroups = [
        ...context.state.subjectGroups.slice(0, index),
        ...context.state.subjectGroups.slice(index + 1)
      ];
      context.commit('setSubjectGroups', subjectGroups);
      context.commit('setSuccess', deleteItemSuccess(data.deleteSubjectGroup.nameLocal));

      return data.deleteSubjectGroup
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

